import React from "react";
import { HiOutlineLightningBolt } from "react-icons/hi";


export default function SpeedInteractive() {
    return (
        <div className="speed-interactive-container">
          <div className="speed-interactive-icon"><HiOutlineLightningBolt size={42} fill="#fff" /></div>
        </div>
    );
}